import React from 'react'
import * as Request from '../../utilities/request'
import { Button, Col, Row } from 'react-bootstrap'
import { useNavigate } from 'react-router-dom'
import NewInvoiceButton from '../invoice/newInvoiceButton'
import { AppContext } from '../../App'
import invoice from '../../images/icons/view_invoice.svg'
import { Switch } from '@material-ui/core'
import { PermissionReturn, Staff } from '../../../../back-end/utilities/apiDefinitions'
import Select from 'react-select'
import { DateTime } from 'luxon'
import { TestingStaff } from '../../screens/dashboard/dashboardWrapper'

interface DashboardHeaderProps {
	showFirmViewToggle: boolean
	firmView: boolean
	setFirmView: React.Dispatch<React.SetStateAction<boolean>>
	showTestingStaffSelect: boolean
	testingStaff: TestingStaff | null
	setTestingStaff: React.Dispatch<React.SetStateAction<TestingStaff | null>>
}

const DashboardHeader = (props: DashboardHeaderProps) => {
	const navigate = useNavigate()
	const { appState } = React.useContext(AppContext)

	const [staff, setStaff] = React.useState<Staff[] | null>(null)
	const [permissions, setPermissions] = React.useState<PermissionReturn[] | null>(null)

	React.useEffect(() => {
		const getData = async () => {
			const [staffRes, permRes] = await Promise.all([Request.get(`staff`), Request.get(`permission`)])

			setStaff(staffRes.data.staff)
			setPermissions(permRes.data)
		}

		if (appState.authState.isLoggedIn && props.showTestingStaffSelect) {
			getData()
		}
	}, [appState.authState, props.showTestingStaffSelect])

	const staffOptions = staff
		? staff
				.sort((a, b) => (a.name < b.name ? -1 : 1))
				.map((s) => ({
					value: s.xpmID,
					label: `${s.name} - ${permissions?.find((p) => p.id === s.permissionID)?.name || 'No Perm'}`,
					role: s.permissionID,
					id: s.userID,
					xpmID: s.xpmID,
				}))
		: []

	const currentPeriod = appState.accounts.find((acc) => acc.accountID === appState.authState.attributes?.['custom:currentAccountId'])?.billySettings
		?.agedWipDate

	return (
		<Row className="background-light align-items-center py-3">
			<Col sm="auto">
				<h4 className="span-extra mb-0">Welcome {appState.authState.attributes?.given_name ? appState.authState.attributes.given_name + '!' : ''}</h4>
			</Col>
			{props.showFirmViewToggle && (
				<Col sm="auto" className="d-flex align-items-center">
					<Switch checked={props.firmView} onChange={() => props.setFirmView((fv) => !fv)} color="primary" />
					<span onClick={() => props.setFirmView((fv) => !fv)}>Firm</span>
				</Col>
			)}
			{props.showTestingStaffSelect && staff && permissions && (
				<Col>
					<Select
						options={staffOptions}
						value={staffOptions.find((so) => so.value === props.testingStaff?.xpmID)}
						onChange={(opt) => props.setTestingStaff(opt ? { id: opt!.id!, role: opt!.role!, xpmID: opt!.xpmID! } : null)}
						isClearable
					/>
				</Col>
			)}
			<Col />
			{currentPeriod && <Col sm="auto">Current Period: {DateTime.fromISO(currentPeriod).toFormat('LLLL yyyy')}</Col>}
			<Col sm="auto">
				<Button variant="secondary" onClick={() => navigate('/wip')}>
					<img src={invoice} className="mr-2" />
					View WIP
				</Button>
			</Col>
			<Col sm="auto">
				<NewInvoiceButton />
			</Col>
		</Row>
	)
}

export default DashboardHeader
